import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a428b6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, "We have received your request, we will validate and get back to you."),
  /*#__PURE__*/_createElementVNode("div", { class: "info-text mt-0" }, [
    /*#__PURE__*/_createTextVNode("For any question contact: "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:list.epx@ciena.com" }, "list.epx@ciena.com")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": true,
    "no-search": true
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}